import { useEffect, useRef } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

const SESSION_WARNING_WINDOW = 30 * 60 * 1000; // 30 minutes

const SessionWatcher = () => {
  const { user, logout } = useAuth();
  const { showToast } = useToast();
  const warnedRef = useRef(false);

  useEffect(() => {
    let warnTimer;
    let logoutTimer;

    const handleForceLogout = () => {
      showToast('Session expired. Please login again.', 'error', 6000);
      logout();
      window.location.href = '/login';
    };

    const setupTimers = () => {
      const token = localStorage.getItem('token');
      const expiry = Number(localStorage.getItem('tokenExpiry'));

      // Reset warning state when user changes or token updates
      warnedRef.current = false;

      if (!token || !user || !expiry) {
        return;
      }

      const now = Date.now();

      if (expiry <= now) {
        handleForceLogout();
        return;
      }

      const warnTime = expiry - SESSION_WARNING_WINDOW;

      if (warnTime <= now && !warnedRef.current) {
        showToast(
          'Session will expire in 30 minutes. Please complete pending work and re-login.',
          'error',
          8000
        );
        warnedRef.current = true;
      } else if (warnTime > now) {
        warnTimer = setTimeout(() => {
          if (!warnedRef.current) {
            showToast(
              'Session will expire in 30 minutes. Please complete pending work and re-login.',
              'error',
              8000
            );
            warnedRef.current = true;
          }
        }, warnTime - now);
      }

      logoutTimer = setTimeout(handleForceLogout, expiry - now);
    };

    setupTimers();

    return () => {
      if (warnTimer) clearTimeout(warnTimer);
      if (logoutTimer) clearTimeout(logoutTimer);
    };
  }, [user, logout, showToast]);

  return null;
};

export default SessionWatcher;

